import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchasesService {

  private URL = environment.api + "api/erp/purchase/invoices";
  constructor(
    private http: HttpClient,
  ) { }

  getPurchasesByIntervalDate(startDate: number, endDate: number) {
    return this.http.get(this.URL + '/search', {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  getPurchasesByIntervalDateAssociated(startDate: number, endDate: number) {
    return this.http.get(this.URL + '/search-associated', {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  getPurchasesByIntervalDateNotAssociated(startDate: number, endDate: number) {
    return this.http.get(this.URL + '/search-not-associated', {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  getPurchasesPendingReceiptByIntervalDate(startDate: number, endDate: number) {
    return this.http.get(this.URL + '/search-virtual', {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  deleteInvoice(invoice: any) {
    return this.http.delete(this.URL + "/" + invoice.id);
  }

  getDetailInvoice(invoice: any) {
    return this.http.get(this.URL + "/detail/" + invoice.id);
  }

  getDetailPurchasesPendingReceipt(id: any) {
    return this.http.get(this.URL + "/detail-virtual/" + id);
  }

  getDetailPurchaseInvoice(id: number) {
    return this.http.get(this.URL + "/detail/" + id);
  }


  putInvoice(invoiceId: number, newData: any) {
    return this.http.put(this.URL + "/" + invoiceId, newData);
  }

  putMovingInvoice(movingId: number, movingData: any) {
    return this.http.put(this.URL + "/move/" + movingId, movingData);
  }

  postInvoice(invoiceData: any) {
    return this.http.post(this.URL, invoiceData);
  }

  getProviderInventory(warehouseId, startDate, endDate) {
    return this.http.get(this.URL + `/inventory/${warehouseId}/${startDate}/${endDate}`);
  }

  getProviderInventoryGeneral(startDate, endDate) {
    return this.http.get(this.URL + `/inventory/general/${startDate}/${endDate}`);
  }

  getProviderChronology(warehouseId: number, startDate: number, endDate: number) {
    if (warehouseId) {
      return this.http.get(this.URL + `/chronology/${warehouseId}/${startDate}/${endDate}`);
    } else {
      return this.http.get(this.URL + `/chronology/general/${startDate}/${endDate}`);
    }
  }

  deleteDuplicatedInvoices(companyId: number, startDate: number, endDate: number) {
		return this.http.delete<any>(`${this.URL}/delete-duplicated/${companyId}`, {
			params: {
				startDate: startDate.toString(),
				endDate: endDate.toString()
			}
		});
	}

}
